import { API } from './resources'

export default {
  getFairsForProject: (projectID) => {
    return API.get(`/projects/${projectID}/fairs`)
  },
  createFairProject: (projectID, data) => {
    return API.put(`/projects/${projectID}/submitToFairs`, data)
  },
  getFairForEvent: (explorePath) => {
    return API.get(`/fairs/path/${explorePath}`)
  },
  getFairForCategory: (category) => {
    return API.get(`/fairs/category/${category}`)
  },
  getFairForTemplate: (templateID) => {
    return API.get(`/fairs/template/${templateID}`)
  },
  getTemplatesForFair: () => {
    return API.get('/templates')
  }
}
